import { render } from "./FileLink.vue?vue&type=template&id=7c749500"
import script from "./FileLink.vue?vue&type=script&lang=ts"
export * from "./FileLink.vue?vue&type=script&lang=ts"
script.render = render

export default script